import React, { FC } from 'react'
import { IconProps } from '@/root/shared-types/ui/ui-types'
import Icon from '@/root/ui/shared/Icon'

export const CancelIcon: FC<IconProps> = ({ width = 18, height = 18, ...rest }) => (
  <Icon type="Cancel" width={width} height={height} alt="Cancel" ignoreRtl {...rest} />
)
